import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
import { View } from '../../View';
import { useUserTime } from '@gopeerproject/chuck';
export const Clock = ({ timezone, name }) => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const time = useUserTime(timezone);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Icon, { name: 'clock', size: size.I, color: (color) => color.invert2.p56 }),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.text },
            "It's ",
            time,
            " for ",
            name)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        paddingVertical: size.C,
        paddingHorizontal: size.C * 2,
        alignItems: 'center'
    },
    text: {
        marginLeft: size.B,
        color: color.invert2.p56
    }
}));
//# sourceMappingURL=Clock.js.map